import MainContainer from "../../components/container/MainContainer";
import StatCards from "../../components/cards/StatCards";
import ActivityGraph from "../../components/graphs/ActivityGraph";
import RecentTransactions from "../../components/cards/RecentTransactions";
import { useAuthorization } from "../../hooks/useAuthorization";
import ProvincialCouncilDashboard from "./ProvincialCouncilDashboard";
import CommunityCouncilDashBoard from "./CommunityCouncilDashBoard";
import PDODashboard from "./PDODashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const { isAuthorized } = useAuthorization();
  const user = useSelector((state) => state.user.userInfo);

  if (isAuthorized("super_admin", "read")) {
    return <SuperAdminDashboard />;
  } else if (isAuthorized("provincial_council", "read")) {
    return <ProvincialCouncilDashboard />;
  } else if (isAuthorized("community_council", "read")) {
    return <CommunityCouncilDashBoard />;
  } else if (isAuthorized("pdo_manager", "read")) {
    return <PDODashboard />;
  } else if (isAuthorized("pdo_department", "read")) {
    return <PDODashboard />;
  }

  return (
    <MainContainer>
      <div className="flex-1 w-full h-full  mb-5">
        <div className="flex-1 h-full ">
          <div className="border border-bkg2 p-2 rounded-md bg-content mb-3 font-roboto">
            <p className="text-lg font-roboto font-bold mb-2 text-center">
              Hello,
              <span className=" font-medium">
                {" " + user.first_name + " " + user.last_name}
              </span>
            </p>

            <p>
              <span>{user.province?.name || "N/A"}</span>
            </p>
            <p>Role:{" " + user.role || "N/A"}</p>
          </div>
          <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-5 sm:h-auto">
            <ActivityGraph />
            <div className="bg-content flex-1 shadow-lg h-60 rounded-lg p-3">
              1
            </div>
          </div>
          <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-5 sm:h-auto">
            <RecentTransactions />
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default Dashboard;
